import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ButtonComp from "./ButtonComp";

export default function ComparisonSection({
  data,
  comparisionTopText,
  comparisionDescriptionText,
  btnImg
}) {
  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState(1); // default PTE selected

  const icons = [
    <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_341_689)">
        <path d="M8 16C3.58867 16 0 12.4113 0 8C0 3.58867 3.58867 0 8 0C12.4113 0 16 3.58867 16 8C16 12.4113 12.4113 16 8 16ZM8 1.33333C4.324 1.33333 1.33333 4.324 1.33333 8C1.33333 11.676 4.324 14.6667 8 14.6667C11.676 14.6667 14.6667 11.676 14.6667 8C14.6667 4.324 11.676 1.33333 8 1.33333ZM9.66667 10.8867C9.986 10.7027 10.0953 10.2947 9.91067 9.976L8.66667 7.82133V4C8.66667 3.632 8.36867 3.33333 8 3.33333C7.63133 3.33333 7.33333 3.632 7.33333 4V8C7.33333 8.11733 7.364 8.232 7.42267 8.33333L8.756 10.6427C8.88 10.8567 9.10333 10.976 9.334 10.976C9.44733 10.976 9.562 10.9473 9.66667 10.8867Z"/>
        </g>
    </svg>,
    <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_341_695)">
        <path d="M16 7.33333C16 6.28667 15.5 5.30667 14.6667 4.68C14.6667 3.41333 13.78 2.34 12.6 2.06667C12.3267 0.886667 11.2667 0 10 0C9.20667 0 8.48667 0.353333 8 0.906667C7.51333 0.353333 6.79333 0 6 0C4.73333 0 3.67333 0.886667 3.4 2.06667C2.22 2.34 1.33333 3.41333 1.33333 4.68C0.5 5.30667 0 6.28667 0 7.33333C0 7.92667 0.16 8.49333 0.46 9C0.16 9.50667 0 10.0733 0 10.6667C0 11.7933 0.573333 12.8267 1.51333 13.4467C1.99333 14.9667 3.38667 16 5 16C6.24 16 7.33333 15.38 8 14.44C8.66667 15.38 9.76 16 11 16C12.6133 16 14.0067 14.96 14.4867 13.4467C15.4267 12.8333 16 11.7933 16 10.6667C16 10.0733 15.84 9.50667 15.54 9C15.84 8.49333 16 7.92667 16 7.33333ZM7.33333 12.3333C7.33333 13.62 6.28667 14.6667 5 14.6667C3.91333 14.6667 2.98 13.92 2.73333 12.86C2.69333 12.6733 2.56667 12.5133 2.4 12.42C1.74667 12.0667 1.33333 11.3933 1.33333 10.6667C1.33333 10.22 1.48667 9.78667 1.78667 9.42C1.98667 9.17333 1.98667 8.82667 1.78667 8.58C1.49333 8.21333 1.33333 7.78 1.33333 7.33333C1.33333 6.62 1.72667 5.95333 2.36 5.6C2.60667 5.46 2.74 5.18 2.68667 4.9C2.67333 4.82667 2.66 4.74667 2.66 4.66667C2.66 3.93333 3.26 3.33333 3.99333 3.33333C4.36 3.33333 4.66 3.03333 4.66 2.66667C4.66 1.93333 5.26 1.33333 5.99333 1.33333C6.72667 1.33333 7.32667 1.93333 7.32667 2.66667V12.3333H7.33333ZM14.2133 9.42C14.5067 9.78667 14.6667 10.22 14.6667 10.6667C14.6667 11.4 14.26 12.0667 13.6 12.42C13.4333 12.5133 13.3067 12.6733 13.2667 12.86C13.02 13.9267 12.0867 14.6667 11 14.6667C9.71333 14.6667 8.66667 13.62 8.66667 12.3333V2.66667C8.66667 1.93333 9.26667 1.33333 10 1.33333C10.7333 1.33333 11.3333 1.93333 11.3333 2.66667C11.3333 3.03333 11.6333 3.33333 12 3.33333C12.7333 3.33333 13.3333 3.93333 13.3333 4.66667C13.3333 4.74667 13.32 4.82667 13.3067 4.9C13.2533 5.18 13.3867 5.46 13.6333 5.6C14.2667 5.96 14.66 6.62 14.66 7.33333C14.66 7.78667 14.5067 8.21333 14.2067 8.58C14.0067 8.82667 14.0067 9.17333 14.2067 9.42H14.2133Z"/>
        </g>
    </svg>,
    <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="currentColor" >
      <path d="M4.5 1.5C4.77614 1.5 5 1.72386 5 2V3C5 3.27614 4.77614 3.5 4.5 3.5C4.22386 3.5 4 3.27614 4 3V2C4 1.72386 4.22386 1.5 4.5 1.5Z" />      
      <path d="M11.5 1.5C11.7761 1.5 12 1.72386 12 2V3C12 3.27614 11.7761 3.5 11.5 3.5C11.2239 3.5 11 3.27614 11 3V2C11 1.72386 11.2239 1.5 11.5 1.5Z" />
      <path d="M4 2.5H12C13.6569 2.5 15 3.84315 15 5.5V11.5C15 13.1569 13.6569 14.5 12 14.5H4C2.34315 14.5 1 13.1569 1 11.5V5.5C1 3.84315 2.34315 2.5 4 2.5ZM2 6V11.5C2 12.6046 2.89543 13.5 4 13.5H12C13.1046 13.5 14 12.6046 14 11.5V6H2Z" />
      <path d="M2 6H14V7H2V6Z" />
    </svg>,
    <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <path d="M16 12.6667V4C16 3.46957 15.7893 2.96086 15.4142 2.58579C15.0391 2.21071 14.5304 2 14 2H2C1.46957 2 0.960859 2.21071 0.585786 2.58579C0.210714 2.96086 0 3.46957 0 4L0 12.6667H7.33333V13.3333H4.66667V14.6667H11.3333V13.3333H8.66667V12.6667H16ZM1.33333 4C1.33333 3.82319 1.40357 3.65362 1.5286 3.5286C1.65362 3.40357 1.82319 3.33333 2 3.33333H14C14.1768 3.33333 14.3464 3.40357 14.4714 3.5286C14.5964 3.65362 14.6667 3.82319 14.6667 4V11.3333H1.33333V4Z"/>
    </svg>
    ];

  return (
    <div className="py-5">
      <div className="custom-container">
        {/* HEADER */}
        <div className="text-center mb-5">
          {comparisionTopText && comparisionTopText()}
          <p
            className="FS18FW400 fw-500 quote-para"
            dangerouslySetInnerHTML={{
              __html: comparisionDescriptionText || "",
            }}
          />
        </div>

        {/* CARDS */}
        <div className="row g-4 justify-content-center">
          {data.map((item, index) => {
            const isActive = activeIndex === index;

            return (
              <div className="col-lg-4 col-md-6" key={index}>
                <div
                  className={`compare-card cursor-default ${isActive ? "active" : ""}`}
                  // onClick={() => { setActiveIndex(index); if (item.ctaLink) navigate(item.ctaLink); }}
                >
                  {/* Recommended Tag */}
                  {item.recommended && (
                    <div className="recommended quote-para FS16FW500">RECOMMENDED CHOICE</div>
                  )}

                  <h4 className="quote-para FS24FW500">{item.title}</h4>
                  <p className="card-subtitle quote-para FS14FW600 mb-2">
                    {item.subtitle}
                  </p>

                  <ul className="feature-list-comparision">
                    {item.features.map((f, i) => (
                      <li key={i} className="feature-item">
                        <div className="feature-left">
                          <span className="feature-icon">{icons[i]}</span>
                          <div>
                            <span className="quote-para label">{f.label}</span>
                            <span className="value quote-para">{f.value}</span>
                          </div>
                        </div>
                      </li>
                    ))}
                  </ul>

                  {/* <button className={`${isActive ? "primary-btn" : 'cta-btn'} cursor-pointer w-100`} onClick={(e) => { e.stopPropagation(); if (item.ctaLink) navigate(item.ctaLink); }}>{item.cta} <img
                      src={btnImg || `/images/web-new-images/${isActive ? 'new-dark-arrow.svg' : 'right-arrow-black.svg'}`}
                      alt="Register Now"
                    /></button> */}
                    <ButtonComp 
  btnText={item.cta}
  link={(e) => {
    e?.stopPropagation?.();
    if (item.ctaLink) navigate(item.ctaLink);
  }}
  img={btnImg || `/images/web-new-images/${isActive ? 'new-dark-arrow.svg' : 'right-arrow-black.svg'}`}
  btnClassName={isActive ? "primary-btn" : 'cta-btn'}
  className="cursor-pointer w-100"
/>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
